function convertToStringHuman(ms) {
  const hours = Math.floor((ms / (1000 * 60 * 60)) % 60);
  const minutes = Math.floor((ms / (1000 * 60)) % 60);
  const seconds = Math.floor((ms / 1000) % 60);

  return `${parseInt(hours) ? `${hours}hrs ` : ""}${minutes}m ${seconds}s`;
}

export default convertToStringHuman;
